import {
  TECHNICIAN_CHANGE_VALUES,
  ADMIN_LOGOUT,
} from '@shared/store/constants/mutationTypes';

import initialState from './technicianInitialState';

const mutations = {
  [TECHNICIAN_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      if (state[field] !== undefined) {
        state[field] = value;
      }
    });
  },
  [ADMIN_LOGOUT]: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
